import { createStore, applyMiddleware, compose } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

export default function configureStore(initialState?: any) {
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
        return createStore(
            rootReducer,
            initialState,
            compose(
                applyMiddleware(thunk, reduxImmutableStateInvariant()),
                window.__REDUX_DEVTOOLS_EXTENSION__()
            )
        );
    }

    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(thunk, reduxImmutableStateInvariant())
    );
}
